/* eslint-disable max-lines */
import {
    QueryPageUsingGetParams,
    HelpDoc,
    UpdateStatusParam,
    CheckDocVersionParam,
    LoadUsingGet1Params,
    HelpDocCategory,
    CopyHelpDocUsingGetParams,
    SelectByPidListUsingGetParams,
    SupportCenterCategory,
    QueryDocListForAddDocUsingGetParams,
    ResDocVo,
    SupportCenterRes,
    LoadResUsingGetParams,
    QueryLogByCoIdUsingGetParams,
    VisitLog,
    CoEnrollVO,
    CoEnrollDTO,
    CoEnrollCountDTO,
    LoadUsingGet4Params
} from '@servicesTypings/companyRequest'
import {
    QuerySourceListUsingGetParams,
    OpSourceVo,
    CompanyMainCategoryBind,
    UpdateCompanyCategoryParam,
    CustomerLabelTypeNameVo,
    ListSelectedCustomerLabelTypeNameUsingGetParams,
    CustomerLabelTypeNameSelectedVo,
    CustomerLabelDTO,
    DeleteCustomerLabelDTO,
    CustomerLabelTypeDTO,
    CustomerLabelNameDTO,
    CustomerLabelName,
    MainCategory,
    HideFindCooperationCategoryParam,
    DeleteCategoryParam
} from '@servicesTypings/drpRequest'

import { companyRequest, securityRequest, openCompanyRequest, drpRequest } from '@/utils/request'
import { captureException } from '@/utils/track'

// 查询文档
/**
 * 分页查询
 */
export function queryDocumentsList(params: QueryPageUsingGetParams): API.Res<HelpDoc[]> {
    return companyRequest.get('/op/helpDoc/queryPage', { params })
}

// 查询文档
/**
 * 获取供销or分销来源列表
 */
export function querySourcesList(params: QuerySourceListUsingGetParams): API.Res<OpSourceVo[]> {
    return drpRequest.get('/op/source/querySourceList', { params })
}

// 查询FFrom
export async function queryFfromList() {
    const res = await securityRequest.get('/security/config/find?key=ERP_JOINT_GYL_FFROM')
    const temp = { ...res }

    if (temp.success) {
        try {
            // eslint-disable-next-line no-eval
            const list = eval(temp.data) || []
            if (Array.isArray(list)) {
                temp.data = list
            }
        } catch (error) {
            console.error('catchError', error)
            captureException('中台FFrom字段格式异常', {
                anchor: '鲷鱼'
            })
            temp.data = []
        }
    }
    return temp
}

// 新增FFrom
export function saveFfromList(data) {
    return securityRequest.post('/security/config/save', { data })
}

// 修改状态
/**
 * 修改状态
 */
export function updateEnableStatus(data: UpdateStatusParam): API.Res<object> {
    return companyRequest.post('/op/helpDoc/updateStatus', { data })
}

// 校验文档版本
/**
 * 校验文档版本
 */
export function checkDocVersion(data: CheckDocVersionParam): API.Res<boolean> {
    return companyRequest.post('/op/supportCenterRes/checkDocVersion', { data })
}

// 查询详情
/**
 * 根据ID查询
 */
export function queryDocumentsDetail(params: LoadUsingGet1Params): API.Res<HelpDoc> {
    return companyRequest.get('/op/helpDoc/load', { params })
}

// 富文本查询详情
/**
 * 根据ID查询
 */
export function queryOpenDocumentsDetail(params: LoadUsingGet4Params): API.Res<HelpDoc> {
    return openCompanyRequest.get('/open/helpDoc/load', { params })
}

// 富文本查询详情浏览次数
/**
 * 更新浏览次数
 */
export function queryOpenViewCount(data: HelpDoc): API.Res<object> {
    return openCompanyRequest.post('/open/helpDoc/updateViewCount', { data })
}

// 删除文档
/**
 * 删除
 */
export function removeDocuments(data: string): API.Res<object> {
    return companyRequest.post('/op/helpDoc/delete', { data })
}

// 检查是否有分类
/**
 * 查询文档分类数量
 */
export function checkHasClassify(): API.Res<number> {
    return companyRequest.get('/op/helpDocCategory/selectCount')
}

// 新增文档
/**
 * 插入
 */
export function createDocuments(data: HelpDoc): API.Res<object> {
    return companyRequest.post('/op/helpDoc/insert', { data })
}

// 更新文档
/**
 * 更新
 */
export function updateDocuments(data: HelpDoc): API.Res<object> {
    return companyRequest.post('/op/helpDoc/update', { data })
}

// 查询分类
/**
 * 查询帮助文档分类列表
 */
export function queryDocCategoryList(): API.Res<HelpDocCategory[]> {
    return companyRequest.get('/op/helpDocCategory/list')
}

// 获取帮助文档分类列表
/**
 * 查询帮助文档分类列表
 */
export function queryClassifyList(): API.Res<HelpDocCategory[]> {
    return companyRequest.get('/op/helpDocCategory/list')
}

// 保存分类
/**
 * 保存
 */
export function saveClassifyList(data: string): API.Res<object> {
    return companyRequest.post('/op/helpDocCategory/save', { data })
}

// 删除分类
/**
 * 删除
 */
export function deleteClassifyList(data: string): API.Res<object> {
    return companyRequest.post('/op/helpDocCategory/deleteCategory', { data })
}

// 删除分类
/**
 * 复制帮助文档
 */
export function copyHelpDoc(params: CopyHelpDocUsingGetParams): API.Res<object> {
    return companyRequest.get('/op/helpDoc/copyHelpDoc', { params })
}

// 商家帮助中心-根据PID查询分类
/**
 * 根据PID查询分类
 */
export function selectByPidList(params: SelectByPidListUsingGetParams): API.Res<SupportCenterCategory[]> {
    return companyRequest.get('/op/supportCenterCategory/selectByPidList', { params })
}

// 商家帮助中心-查询文档列表(资源位添加文章用)
/**
 * 查询文档列表(资源位添加文章用)
 */
export function queryDocListForAddDoc(params: QueryDocListForAddDocUsingGetParams): API.Res<ResDocVo[]> {
    return companyRequest.get('/op/supportCenterDoc/queryDocListForAddDoc', { params })
}

// 商家帮助中心-插入资源位
/**
 * 插入资源位
 */
export function insertRes(data: SupportCenterRes): API.Res<object> {
    return companyRequest.post('/op/supportCenterRes/insertRes', { data })
}

// 商家帮助中心-查询资源位
/**
 * 查询资源位
 */
export function loadRes(params: LoadResUsingGetParams): API.Res<SupportCenterRes> {
    return companyRequest.get('/op/supportCenterRes/loadRes', { params })
}

// 商家帮助中心-更新资源位
/**
 * 修改资源位
 */
export function updateRes(data: SupportCenterRes): API.Res<object> {
    return companyRequest.post('/op/supportCenterRes/updateRes', { data })
}

// 获取商家分类绑定关系
/**
 * 获取商家分类绑定关系
 */
export function getBindCategoryList(data: string[]): API.Res<CompanyMainCategoryBind[]> {
    return drpRequest.post('/op/mainCategory/getBindCategoryList', { data })
}

// 更新商家分类绑定关系
/**
 * 更新商家分类绑定关系
 */
export function updateBindCategory(data: UpdateCompanyCategoryParam): API.Res<boolean> {
    return drpRequest.post('/op/mainCategory/updateBindCategory', { data })
}

// 校验类目是否已被使用
/**
 * swagger找不到此接口
 */
export function checkUsedCategory(params) {
    return drpRequest.get('op/mainCategory/checkUsedCategory', {
        params
    })
}

// 根据coId查询拜访日志
/**
 * 根据coId查询拜访日志
 */
export function queryLogByCoId(params: QueryLogByCoIdUsingGetParams): API.Res<VisitLog[]> {
    return companyRequest.get('/op/visitLog/queryLogByCoId', { params })
}

// 查询标签列表
/**
 * 查询标签列表
 */
export function customerLabelTypes(): API.Res<CustomerLabelTypeNameVo[]> {
    return drpRequest.get('/op/customerLabelTypes')
}

// 查询设置标签列表
/**
 * 查询设置标签列表
 */
export function customerLabelTypesSelected(
    params: ListSelectedCustomerLabelTypeNameUsingGetParams
): API.Res<CustomerLabelTypeNameSelectedVo[]> {
    return drpRequest.get('/op/customerLabelTypes/selected', { params })
}

// 查询设置标签列表过滤掉无标签名
/**
 * 查询设置标签列表过滤掉无标签名
 */
export function customerFilterLabelList(): API.Res<CustomerLabelTypeNameSelectedVo[]> {
    return drpRequest.get('/op/customerLabelTypes/selected/filter')
}

// 添加标签
/**
 * 添加标签
 */
export function addCustomerLabels(data: CustomerLabelDTO): API.Res<object> {
    return drpRequest.post('/op/customerLabels', { data })
}

// 移除标签
/**
 * 移除标签
 */
export function removeCustomerLabels(data: DeleteCustomerLabelDTO): API.Res<object> {
    return drpRequest.post('/op/customerLabels/delete', { data })
}

// 保存标签类型
/**
 * 保存标签类型
 */
export function saveLabelType(data: CustomerLabelTypeDTO): API.Res<object> {
    return drpRequest.post('/op/customerLabelTypes/save', { data })
}

// 保存标签名称
/**
 * 保存标签名称
 */
export function saveLabelName(data: CustomerLabelNameDTO): API.Res<object> {
    return drpRequest.post('/op/customerLabelNames/save', { data })
}

// 删除标签名称
/**
 * 删除标签名称
 */
export function deleteLabelName(): API.Res<object> {
    return drpRequest.post('/op/customerLabelNames/delete')
}

// 删除标签类型
/**
 * 删除标签类型
 */
export function deleteLabelType(): API.Res<object> {
    return drpRequest.post('/op/customerLabelTypes/delete')
}

// 获取全部有效的标签名称集合
/**
 * 获取全部有效的标签名称集合
 */
export function getAllLabel(): API.Res<CustomerLabelName[]> {
    return drpRequest.get('/op/customerLabelNames/query/normal/labels')
}

// 商家报名
/**
 * 商家报名
 */
export function apply(data: CoEnrollVO): API.Res<string> {
    return companyRequest.post('/op/docCo/insert', { data })
}

// 判断商家是否已经报名
/**
 * 判断是否已经报名
 */
export function checkEnroll(data: CoEnrollVO): API.Res<string> {
    return companyRequest.post('/op/docCo/checkEnroll', { data })
}

// 根据文档id查询下面绑定的商家信息
/**
 * 根据文档id查询下面绑定的商家信息
 */
export function queryBySourceId(data: string): API.Res<CoEnrollDTO[]> {
    return companyRequest.post('/op/docCo/queryBySourceId', { data })
}

// 根据文档id集合查询下面绑定的商家数量
/**
 * 根据文档id集合查询下面绑定的商家数量
 */
export function queryCount(data: string): API.Res<CoEnrollCountDTO[]> {
    return companyRequest.post('/op/docCo/queryCount', { data })
}

// 导出报名商家详情
/**
 * 导出报名商家详情
 */
export function applyExport(data: CoEnrollVO): API.Res<string> {
    return companyRequest.post('/op/docCo/export', { data })
}

// 获取商家类目列表
/**
 * 查询类目列表
 */
export function companyCategory(): API.Res<MainCategory[]> {
    return drpRequest.get('/op/mainCategory/list')
}

// 保存类目
/**
 * 保存类目
 */
export function mainCategorySave(data: MainCategory[]): API.Res<object> {
    return drpRequest.post('/op/mainCategory/saveCategory', { data })
}

// 寻合作中隐藏类目
/**
 * 寻合作中隐藏类目
 */
export function hideFindCooperationCategory(data: HideFindCooperationCategoryParam): API.Res<object> {
    return drpRequest.post('/op/mainCategory/hideFindCooperationCategory', { data })
}

// 删除类目
/**
 * 删除类目
 */
export function deleteMainCategory(data: DeleteCategoryParam): API.Res<object> {
    return drpRequest.post('/op/mainCategory/deleteCategory', { data })
}

// 校验是否可以删除类目
/**
 * 校验是否可以删除类目
 */
export function checkCanDeleteMainCategory(data: DeleteCategoryParam): API.Res<boolean> {
    return drpRequest.post('/op/mainCategory/checkCanDeleteCategory', { data })
}
